enum PublicAssetVariant {
  CommunityThumbnail = 'CommunityThumbnail',
  GatheringThumbnail = 'GatheringThumbnail',
  Undetermined = 'Undetermined'
}
export default PublicAssetVariant
